/**
 * User Profile Tour Step Definitions.
 * Declarative, engine-agnostic configuration for the User Profile & Settings guide.
 */
export const profileTourConfig = {
  id: 'profile-onboarding',
  storageKey: 'triad_tour_profile_completed',
  steps: [
    {
      id: 'profile-avatar',
      target: '[data-tour="profile-avatar"]',
      titleKey: 'tour.profile.avatarTitle',
      descriptionKey: 'tour.profile.avatarDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true
    },
    {
      id: 'profile-basic-info',
      target: '[data-tour="profile-basic-info"]',
      titleKey: 'tour.profile.basicTitle',
      descriptionKey: 'tour.profile.basicDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true
    },
    {
      id: 'profile-preferences',
      target: '[data-tour="profile-preferences"]',
      titleKey: 'tour.profile.preferencesTitle',
      descriptionKey: 'tour.profile.preferencesDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true
    },
    {
      id: 'profile-notifications',
      target: '[data-tour="profile-notifications"]',
      titleKey: 'tour.profile.notificationsTitle',
      descriptionKey: 'tour.profile.notificationsDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true
    },
    {
      id: 'profile-membership',
      target: '[data-tour="profile-membership"]',
      titleKey: 'tour.profile.membershipTitle',
      descriptionKey: 'tour.profile.membershipDesc',
      position: 'bottom',
      align: 'start',
      scrollIntoView: true,
      allowMissing: true
    },
    {
      id: 'profile-security',
      target: '[data-tour="profile-security"]',
      titleKey: 'tour.profile.securityTitle',
      descriptionKey: 'tour.profile.securityDesc',
      position: 'top',
      align: 'start',
      scrollIntoView: true
    },
    {
      id: 'profile-danger',
      target: '[data-tour="profile-danger"]',
      titleKey: 'tour.profile.dangerTitle',
      descriptionKey: 'tour.profile.dangerDesc',
      position: 'top',
      align: 'start',
      scrollIntoView: true,
      allowMissing: true
    }
  ]
};

export default profileTourConfig;
